import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'elevated' | 'glass';
  onClick?: () => void;
}

/**
 * Componente Card con múltiples variantes y efectos modernos
 */
export const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  variant = 'default',
  onClick
}) => {
  const baseClasses = 'rounded-2xl transition-all duration-300';
  
  const variants = {
    default: 'bg-slate-800 border border-slate-600 shadow-xl',
    elevated: 'bg-slate-800 border border-slate-600 shadow-2xl hover:shadow-emerald-500/10',
    glass: 'bg-slate-900/30 backdrop-blur-md border border-white/20 shadow-md'
  };

  return (
    <div 
      className={`${baseClasses} ${variants[variant]} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;